import { SectionBlockSubtitle } from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { cn } from 'src/utils/shadcn';

type Props = {
    title: string;
    className?: string;
    isLoading?: boolean;
    value?: number;
    totalValue?: number;
};
export default function StatisticValue({ title, isLoading, value, totalValue, className }: Props) {
    return (
        <div className={cn('flex flex-col items-center', className)}>
            <SectionBlockSubtitle className="text-center text-sm font-medium">{title}</SectionBlockSubtitle>
            {isLoading ? (
                <Skeleton className="h-8 w-27" />
            ) : (
                <p className="text-sm">
                    <span className="text-2xl font-semibold">{value}</span>
                    {totalValue && totalValue >= 0 && '/'}
                    {totalValue && `${totalValue}`}
                </p>
            )}
        </div>
    );
}
